// App.js Modificato
import "./styles.css";

import React from "react";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pagine/Home";
import Corsi from "./pagine/Corsi";
import News from "./pagine/News";
import Passati from "./pagine/Passati";
import Galleria from "./pagine/Galleria";
import AlbumContent from "./pagine/AlbumContent";
import Login from "./pagine/admin/Login";
import Dashboard from "./pagine/admin/Dashboard";
import ProtectedRoute from "./componenti/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { CustomThemeProvider, useCustomTheme } from "./context/ThemeContext";

// Componenti UI e Context
import { useMediaQuery } from "react-responsive";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";

function MainLayout() {
  const location = useLocation();
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const currentTab = location.pathname === '/' ? 'home' : location.pathname.split('/')[1];
  const { themeSettings } = useCustomTheme();
  const isDashboard = location.pathname.startsWith('/admin/dashboard');

  return (
    <TabContext value={currentTab}>
      <Box sx={{ width: "100%" }}>
        {!isDashboard && (
          <Box sx={{
            display: { xs: 'block', sm: 'flex' },
            justifyContent: 'center',
            borderBottom: 0,
            borderRight: 0,
            borderColor: "divider",
            bgcolor: themeSettings?.header_bg || "#fff"
          }}>
          <TabList
            orientation={isMobile ? "vertical" : "horizontal"}
            variant={isMobile ? 'fullWidth' : 'standard'}
            sx={{
              ...(isMobile && {
                '& .MuiTab-root': {
                  mx: 2,
                  my: 0.5,
                  borderRadius: '12px',
                },
                '& .MuiTab-root.Mui-selected': {
                  backgroundColor: 'rgba(0, 0, 0, 0.06)',
                }
              })
            }}
            slotProps={{
              indicator: {
                sx: {
                  right: isMobile ? 0 : 'auto',
                  width: isMobile ? 3 : 'auto',
                  display: isMobile ? 'none' : 'block'
                }
              }
            }}
          >
            <Tab component={Link} to="/home" value="home" label="Home" />
            <Tab component={Link} to="/corsi" value="corsi" label="Orari" />
            <Tab component={Link} to="/news" value="news" label="News" />
            <Tab component={Link} to="/passati" value="passati" label="Eventi Passati" />
            <Tab component={Link} to="/galleria" value="galleria" label="Galleria" />
          </TabList>
        </Box>
        )}

        <Box sx={{ padding: "0px" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/corsi" element={<Corsi />} />
            <Route path="/news" element={<News />} />
            <Route path="/passati" element={<Passati />} />
            <Route path="/galleria" element={<Galleria />} />
            <Route path="/galleria/:albumSlug" element={<AlbumContent />} />
            
            {/* Rotte Admin */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
          </Routes>
        </Box>
      </Box>
    </TabContext>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CustomThemeProvider>
        <BrowserRouter>
          <MainLayout />
        </BrowserRouter>
      </CustomThemeProvider>
    </AuthProvider>
  );
}